import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from "./contexts/LanguageContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { HeroSection } from "./components/HeroSection";
import { LocationsBar } from "./components/LocationsBar";
import { PricingSection } from "./components/PricingSection";
import { PaymentMethodsSection } from "./components/PaymentMethodsSection";
import { TechnicalSection } from "./components/TechnicalSection";
import { FeaturesSection } from "./components/FeaturesSection";
import { HardwareSection } from "./components/HardwareSection";
import { UseCasesSection } from "./components/UseCasesSection";
import { OSTableSection } from "./components/OSTableSection";
import { SupportPage } from "./components/SupportPage";
import { AboutPage } from "./components/AboutPage";
import { TermsPage } from "./components/TermsPage";
import { PrivacyPage } from "./components/PrivacyPage";
import { CookiePage } from "./components/CookiePage";
import { RefundPage } from "./components/RefundPage";
import { LegalHubPage } from "./components/LegalHubPage";
import { CompliancePage } from "./components/CompliancePage";
import { AffiliatePage } from "./components/AffiliatePage";
import { AffiliateTermsPage } from "./components/AffiliateTermsPage";
import { NetherlandsPage } from "./components/NetherlandsPage";
import { GermanyPage } from "./components/GermanyPage";
import { PolandPage } from "./components/PolandPage";
import { LatviaPage } from "./components/LatviaPage";
import { RomaniaPage } from "./components/RomaniaPage";
import { ItalyPage } from "./components/ItalyPage";
import { SwitzerlandPage } from "./components/SwitzerlandPage";
import { USAPage } from "./components/USAPage";
import { MiamiPage } from "./components/MiamiPage";
import { CzechiaPage } from "./components/CzechiaPage";
import { BulgariaPage } from "./components/BulgariaPage";
import { GreecePage } from "./components/GreecePage";
import { SpainPage } from "./components/SpainPage";
import { UkrainePage } from "./components/UkrainePage";
import { ApiPage } from "./components/ApiPage";
import { SnapshotPage } from "./components/SnapshotPage";
import { SEO } from "./components/SEO";
import { WikiIndexPage } from "./components/WikiIndexPage";
import { WikiArticlePage } from "./components/WikiArticlePage";
import { VPNPage } from "./components/VPNPage";
import { NotFoundPage } from "./components/NotFoundPage";
import { ScrollToTop } from "./components/ScrollToTop";
import { CookieBanner } from "./components/CookieBanner";

import { captureReferralCode } from "./lib/referral";

// Capture referral code from URL on app load
captureReferralCode();

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO page="home" />
      <Header />
      <main className="bg-white">
        <HeroSection />
        <LocationsBar />
        <HardwareSection />
        <PricingSection />
        <PaymentMethodsSection />
        <FeaturesSection />
        <UseCasesSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <LanguageProvider>
            <ScrollToTop />
            <Routes>
            {/* English routes */}
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Home />} />
            <Route path="/locations" element={<Home />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/vpn" element={<VPNPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<Home />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/cookie" element={<CookiePage />} />
            <Route path="/refund" element={<RefundPage />} />
            <Route path="/legal" element={<LegalHubPage />} />
            <Route path="/compliance" element={<CompliancePage />} />
            <Route path="/affiliate" element={<AffiliatePage />} />
            <Route path="/affiliate-terms" element={<AffiliateTermsPage />} />
            <Route path="/vps-netherlands" element={<NetherlandsPage />} />
            <Route path="/vps-germany" element={<GermanyPage />} />
            <Route path="/vps-poland" element={<PolandPage />} />
            <Route path="/vps-latvia" element={<LatviaPage />} />
            <Route path="/vps-romania" element={<RomaniaPage />} />
            <Route path="/vps-italy" element={<ItalyPage />} />
            <Route path="/vps-switzerland" element={<SwitzerlandPage />} />
            <Route path="/vps-usa" element={<USAPage />} />
            <Route path="/vps-miami" element={<MiamiPage />} />
            <Route path="/vps-czechia" element={<CzechiaPage />} />
            <Route path="/vps-bulgaria" element={<BulgariaPage />} />
            <Route path="/vps-greece" element={<GreecePage />} />
            <Route path="/vps-spain" element={<SpainPage />} />
            <Route path="/vps-ukraine" element={<UkrainePage />} />
            <Route path="/developers" element={<ApiPage />} />
            <Route path="/snapshots" element={<SnapshotPage />} />
            <Route path="/wiki" element={<WikiIndexPage />} />
            <Route path="/wiki/:slug" element={<WikiArticlePage />} />

            {/* Russian routes - same pages with /ru prefix */}
            <Route path="/ru" element={<Home />} />
            <Route path="/ru/pricing" element={<Home />} />
            <Route path="/ru/locations" element={<Home />} />
            <Route path="/ru/support" element={<SupportPage />} />
            <Route path="/ru/vpn" element={<VPNPage />} />
            <Route path="/ru/about" element={<AboutPage />} />
            <Route path="/ru/contact" element={<Home />} />
            <Route path="/ru/terms" element={<TermsPage />} />
            <Route path="/ru/privacy" element={<PrivacyPage />} />
            <Route path="/ru/cookie" element={<CookiePage />} />
            <Route path="/ru/refund" element={<RefundPage />} />
            <Route path="/ru/legal" element={<LegalHubPage />} />
            <Route path="/ru/compliance" element={<CompliancePage />} />
            <Route path="/ru/affiliate" element={<AffiliatePage />} />
            <Route path="/ru/affiliate-terms" element={<AffiliateTermsPage />} />
            <Route path="/ru/vps-netherlands" element={<NetherlandsPage />} />
            <Route path="/ru/vps-germany" element={<GermanyPage />} />
            <Route path="/ru/vps-poland" element={<PolandPage />} />
            <Route path="/ru/vps-latvia" element={<LatviaPage />} />
            <Route path="/ru/vps-romania" element={<RomaniaPage />} />
            <Route path="/ru/vps-italy" element={<ItalyPage />} />
            <Route path="/ru/vps-switzerland" element={<SwitzerlandPage />} />
            <Route path="/ru/vps-usa" element={<USAPage />} />
            <Route path="/ru/vps-miami" element={<MiamiPage />} />
            <Route path="/ru/vps-czechia" element={<CzechiaPage />} />
            <Route path="/ru/vps-bulgaria" element={<BulgariaPage />} />
            <Route path="/ru/vps-greece" element={<GreecePage />} />
            <Route path="/ru/vps-spain" element={<SpainPage />} />
            <Route path="/ru/vps-ukraine" element={<UkrainePage />} />
            <Route path="/ru/developers" element={<ApiPage />} />
            <Route path="/ru/snapshots" element={<SnapshotPage />} />
            <Route path="/ru/wiki" element={<WikiIndexPage />} />
            <Route path="/ru/wiki/:slug" element={<WikiArticlePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
            <CookieBanner />
          </LanguageProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;